import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, queryClient } from '@/api/common';
import type { Admin } from '@/api/partners/admins/types';
import { useAdmin } from '@/api/partners/admins/use-admin';

type Response = {
  data: {
    eonOneTutorialCompletedAt: string;
  };
};

export const useCompleteEonOneTutorial = createMutation<
  Response,
  void,
  AxiosError
>({
  mutationFn: async () =>
    client
      .post('v2/internal/partners/organizations/eon_one_tutorial')
      .then((response) => response.data),
  onSuccess: (result) => {
    queryClient.setQueryData(
      useAdmin.getKey(),
      (current: Admin | undefined) => {
        if (!current?.organization) {
          return current;
        }

        return {
          ...current,
          organization: {
            ...current.organization,
            eonOneTutorialCompletedAt: result.data.eonOneTutorialCompletedAt,
          },
        };
      }
    );
  },
});
